import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { DEFAULT_LOCALE, messages } from './locales';
import { getStoredLocale } from './shared/helpers/localeStorage';

Vue.use(VueI18n);

export default new VueI18n({
  locale: getStoredLocale() || DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages
});
